import {Platform} from 'react-native';
import {
  EditorLayer,
  EditorProject,
  EncoderProject,
  Media,
} from '../../../types';
import * as ExpoFileSystem from 'expo-file-system';
// const path = require('react-native-path')

const documentDir =
  Platform.OS === 'web'
    ? ''
    : ExpoFileSystem.documentDirectory?.replace('file://', '') || '';
export const genRenderCmd = (
  projectData: EditorProject,
  layers: EditorLayer[],
  isPrerender?: boolean,
) => {
  if (projectData?.id === undefined || layers?.length < 1)
    return {execCmd: [], medias: [], files: []};
  const fileId = `${projectData.id}_render_`;
  const {editor: encoding} = projectData;
  const outPostfix = `.output.${encoding?.lastUpdated || 0}.${
    encoding?.output || 'mp4'
  }`;
  const outFileId = fileId + outPostfix;
  // const threads =
  //   Platform.OS === 'web' &&
  //   window.navigator.hardwareConcurrency.toString();
  const extraCode: string[] =
    encoding?.code && encoding.code[0] != ''
      ? encoding.code
          .filter(i => i !== '')
          .map(i =>
            i
              .trim()
              .replace(/[\r\n]+/gm, '')
              .trim(),
          )
      : [];
  const medias = layers
    ?.map(layer => layer?.media?.map(m => ({...m, layer})))
    .flat()
    .filter(i => i);
  const files =
    medias
      ?.map(e => [
        '-i',
        Platform.OS === 'web'
          ? `${documentDir}${e?.id}_${e?.filename}.output.${
              e?.encoding?.lastUpdated || 0
            }.${e?.encoding?.output || 'mp4'}`
          : `"${documentDir}${e?.folderId}/${e?.id}_${e?.filename}"`,
      ])
      .flat() || [];
  let hasAudio = layers?.reduce((a, layer) => {
    if (a === true) return a;

    return !layer.editor?.muted;
  }, false);
  const hasVideo = layers?.reduce((a, layer) => {
    if (a === true) return a;

    return !layer.editor?.videoDisabled;
  }, false);
  const audioOutput = hasAudio ? '[a_concat]' : '';
  const audioMap = hasAudio ? ['-map', audioOutput] : [];
  const videoOutput = hasVideo ? '[v_concat]' : '';
  const videoMap = hasVideo ? ['-map', videoOutput] : [];
  const aspectRatio = encoding.aspectRatio || '16/9';
  const width = encoding?.width || 1280;
  const height = encoding?.height || 720;
  const countDiff = (videoWidth?: number, videoHeight?: number) => {
    return [2, 2];
    // return [videoWidth ? Math.round((width/videoWidth)*10) : 2, videoHeight ? Math.round((height/videoHeight)*10) : 2]
  };
  const scale = (diff: number[]) =>
    `setdar=${aspectRatio},scale=${width}:${height}:force_original_aspect_ratio=decrease,pad=${width}:${height}:(ow-iw)/${diff[0]}:(oh-ih)/${diff[1]}:black,setsar=1`;
  const filterTrim =
    medias?.map((e, index) => {
      const trimV =
        `[${index}:v]trim=start=${
          e?.encoding.start || 0
        }:end=${parseInt(
          (e?.encoding?.end || (e?.duration as number)).toString(),
        )},setpts=PTS-STARTPTS` +
        ',' +
        scale(countDiff(e?.width, e?.height)) +
        `[v${index}]`;

      const trimA = `[${index}:a]atrim=start=${
        e?.encoding.start || 0
      }:end=${parseInt(
        (e?.encoding?.end || (e?.duration as number)).toString(),
      )},asetpts=PTS-STARTPTS[a${index}]`;
      //`,volume=${e?.encoding?.soundVolume/100 || 1},amix[a${index}]`
      let trim = trimV + ',' + trimA;
      if (e?.layer?.editor?.muted) trim = trimV;
      if (e?.layer?.editor?.videoDisabled) trim = trimA;
      return trim;
    }) || [];
  // console.info('medias', medias)
  const videosLength =
    medias?.filter(i => i?.layer?.editor?.videoDisabled !== true)
      .length || 1;
  const audiosLength =
    medias?.filter(i => i?.layer?.editor?.muted !== true).length || 0;
  const videoConcat =
    (medias
      ?.map((a, i) => {
        if (a?.layer?.editor?.videoDisabled !== true)
          return `[v${i}]`;
        return undefined;
      })
      ?.filter(i => i)
      .join('') || '') +
    `concat=n=${videosLength}:v=1:a=0${videoOutput}`;
  let audioConcat = audiosLength
    ? (medias
        ?.map((a, i) => {
          if (a?.layer?.editor?.muted !== true) return `[a${i}]`;
          return undefined;
        })
        ?.filter(i => i)
        ?.join('') || '') +
      `concat=n=${audiosLength}:v=0:a=1${audioOutput}`
    : undefined;
  // [a3]volume=enable='between(t,0,49)'${audioOutput}`
  let filterConcat = videoConcat + ';' + audioConcat;
  if (!audioConcat) filterConcat = videoConcat;
  if (!videoConcat && audioConcat) filterConcat = audioConcat;
  filterTrim.push(filterConcat);
  const trimJoin = filterTrim.join(';');
  const trimJoinPlatform =
    Platform.OS === 'web' ? trimJoin : `"${trimJoin}"`;
  const execCmd: string[] = [
    ...files,
    '-crf',
    encoding?.compressionLevel?.toString() || '20',
    // '-threads',
    // threads,
    '-filter_complex',
    trimJoinPlatform,
    '-aspect',
    aspectRatio,
    '-preset',
    `${encoding?.preset}`,
    '-movflags',
    '+faststart',
    // '+global_header',
    // '-q:v 4',
    // '-c:v libopenh264',
    ...extraCode,
    ...videoMap,
    ...audioMap,
    // '-vsync',
    // '2',
    '-r',
    encoding?.framerate?.toString() || '30',
    '-y',
    `${documentDir}${outFileId}`,
  ];
  // console.log('renderCmd', execCmd.join('\n'))
  return {execCmd, medias, files, outFileId};
};
